import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "@/App.css";
import "./lib/theme";
import "./theme-dark.css";
import { Toaster } from "sonner";

import { AuthProvider } from "./context/AuthContext";
import { SettingsProvider } from "./context/SettingsContext";
import { FeatureProvider } from "./context/FeatureContext";
import FeatureGate from "./components/FeatureGate";
import ProtectedRoute from "./components/ProtectedRoute";
import Layout from "./components/Layout";
import ErrorBoundary from "./components/ErrorBoundary";

import Login from "./pages/Login";
import Register from "./pages/Register";
import Landing from "./pages/Landing";
import Dashboard from "./pages/Dashboard";
import Projects from "./pages/Projects";
import ProjectManagement from "./pages/ProjectManagement";
import InvestorDashboard from "./pages/InvestorDashboard";
import NewProject from "./pages/NewProject";
import ProjectDetail from "./pages/ProjectDetail";
import PublicQuote from "./pages/PublicQuote";
import CustomerPortal from "./pages/CustomerPortal";
import Analytics from "./pages/Analytics";
import Settings from "./pages/Settings";
import Users from "./pages/Users";
import Operations from "./pages/Operations";
import IncomeLedger from "./pages/IncomeLedger";
import Assets from "./pages/Assets";
import Opex from "./pages/Opex";
import InviteAccept from "./pages/InviteAccept";
import PublicInvestorShare from "./pages/PublicInvestorShare";

function Shell({ children }) {
  return (
    <ProtectedRoute>
      <Layout>{children}</Layout>
    </ProtectedRoute>
  );
}

export default function App() {
  return (
    <div className="App">
      <Toaster position="top-right" richColors closeButton />
      <ErrorBoundary>
        <BrowserRouter>
          <SettingsProvider>
            <AuthProvider>
              <FeatureProvider>
              <Routes>
                <Route path="/login" element={<Login />} />
                <Route path="/register" element={<Register />} />
                <Route path="/q/:token" element={<PublicQuote />} />
                <Route path="/p/:token" element={<CustomerPortal />} />
                <Route path="/invite/:token" element={<InviteAccept />} />
                <Route path="/share/investor/:token" element={<PublicInvestorShare />} />
                <Route path="/" element={<Landing />} />
                <Route path="/dashboard" element={<Shell><Dashboard /></Shell>} />
                <Route path="/projects" element={<Shell><FeatureGate feature="projects"><Projects /></FeatureGate></Shell>} />
                <Route path="/pm" element={<Shell><FeatureGate feature="projects"><ProjectManagement /></FeatureGate></Shell>} />
                <Route path="/pm/investor" element={<Shell><InvestorDashboard /></Shell>} />
                <Route path="/projects/new" element={<Shell><FeatureGate feature="projects"><NewProject /></FeatureGate></Shell>} />
                <Route path="/projects/:id" element={<Shell><FeatureGate feature="projects"><ProjectDetail /></FeatureGate></Shell>} />
                <Route path="/operations" element={<Shell><Operations /></Shell>} />
                <Route path="/users" element={<Shell><Users /></Shell>} />
                <Route path="/analytics" element={<Shell><FeatureGate feature="analytics"><Analytics /></FeatureGate></Shell>} />
                <Route path="/income" element={<Shell><IncomeLedger /></Shell>} />
                <Route path="/assets" element={<Shell><Assets /></Shell>} />
                <Route path="/opex" element={<Shell><Opex /></Shell>} />
                <Route path="/settings" element={<Shell><Settings /></Shell>} />
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
              </FeatureProvider>
            </AuthProvider>
          </SettingsProvider>
        </BrowserRouter>
      </ErrorBoundary>
    </div>
  );
}
